import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import Box from 'components/box'
import Loader from 'components/loader'

import styles from './load-more.css'

const LoadMore = ({ loading, onClick }) => (
  <div styleName="load-more">
    <Box interactive={!loading}>
      <div styleName="content" onClick={onClick}>
          {loading ? <Loader center /> : 'Load more'}
      </div>
    </Box>
  </div>
)

LoadMore.propTypes = {
  loading: PropTypes.bool,
  onClick: PropTypes.func,
}

export default CSSModules(LoadMore, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/load-more/load-more.js
 **/